// src/Store/reducers/uploadsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import endpointList from "../../config/endpointList.jsx";
import axios from 'axios'

const BASE = endpointList.postUploads

export const uploadImages = createAsyncThunk(
  'uploads/uploadImages',
  async (files, { rejectWithValue }) => {
    try {
      const uploads = await Promise.all(
        files.map(async (file) => {
          const formData = new FormData()
          formData.append('image', file)
          const { data } = await axios.post(
            `${BASE}/api/upload-image`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          )
          return data.data
        })
      )
      return uploads
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message)
    }
  }
)



const uploadsSlice = createSlice({
  name: 'uploads',
  initialState: {
    uploadedImages: [],   // ← make sure this matches what you select below!
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (b) => {
    b
      .addCase(uploadImages.pending, (s) => { s.loading = true; s.error = null })
      .addCase(uploadImages.fulfilled, (s, a) => {
        s.loading = false
        s.uploadedImages.push(...a.payload)
      })
      .addCase(uploadImages.rejected, (s, a) => {
        s.loading = false
        s.error = a.payload || a.error.message
      })

   
  },
})

export default uploadsSlice.reducer
